import React, { useId } from "react";

/** diagrams.free mark (icon only). Source: docs/logo.svg */
export const ProductLogoIcon = ({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) => {
  const gradientId = useId();

  return (
    <svg
      viewBox="0 0 4335 4335"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden
    >
      <defs>
        <linearGradient
          id={gradientId}
          gradientUnits="userSpaceOnUse"
          x1="2167.33"
          x2="2167.33"
          y1="381.09"
          y2="3953.83"
        >
          <stop offset="0" stopColor="#66c" />
          <stop offset=".509804" stopColor="#f0f" />
          <stop offset="1" stopColor="#f60" />
        </linearGradient>
      </defs>
      <path
        d="m3674 2369c-111 0-202-91-202-202s91-201 202-201 201 90 201 201-90 202-201 202zm-948 980c-32 0-58-25-58-57v-1067h-712v1263h451c31 0 57 26 57 58v350c0 32-26 58-57 58h-1017c-32 0-57-26-57-58v-350c0-32 25-58 57-58h451v-1263h-712v1067c0 76-116 76-116 0v-1067h-403l-511 511c-42 43-115-1-95-59l171-512-171-507c-20-57 53-102 95-59l511 511h403v-1067c0-76 116-76 116 0v1067h712v-1263h-451c-32 0-57-26-57-58v-350c0-32 25-58 57-58h1017c31 0 57 26 57 58v350c0 32-26 58-57 58h-451v1263h712v-1067c0-76 115-76 115 0v1067h370v-679c0-46 52-73 90-47l1066 736c33 23 33 72 0 95l-1066 736c-37 26-90-1-90-48v-678h-370v1067c0 32-25 57-57 57zm542-1808v1253l907-627zm-3076 314 99 291c4 12 4 25 0 37l-100 298 314-314zm1256-1124h901v-235h-901zm0 3107h901v-234h-901zm2226-1756c-113 0-113 171 0 171s113-171 0-171z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
};
